import React, { useState } from 'react';
import { makeStyles, Button } from '@material-ui/core';
import Drawer from '@material-ui/core/Drawer';
import CloseIcon from '@material-ui/icons/Close';
import clsx from 'clsx';
import { Formik, Form } from 'formik';
import GreenButton from '../Shared/GreenButton';
import { useTranslation } from 'react-i18next';
import RawMaterialsTable from './RawMaterialsTable';
import AdditivesTable from './AdditivesTable';
import * as Yup from 'yup';
import { dataService } from '../../Services/data.service'
import { toast } from 'react-toastify';
import AlertDialog from '../Shared/Dialogs/AlertDialog';

export default function ManualReplenishmentDrawer(props) {
    const classes = useStyles();

    const [materials, setMaterials] = useState([]);
    const [validationOK, setValidationOK] = useState(false);
    const [wrongBarcodeDialogOpen, setWrongBarcodeDialogOpen] = useState(false);
    const [emptyPalletDialogOpen, setEmptyPalletDialogOpen] = useState(false);
    const [dialogTitle, setDialogTitle] = useState(null);
    const [dialogContext, setDialogContext] = useState(null);
    const [dialogTitle2, setDialogTitle2] = useState(null);
    const [dialogContext2, setDialogContext2] = useState(null);

    const { t } = useTranslation();

    let shape = {};
    let initialValues = {};

    function siloChanged(siloName, id) {
        let tempMaterials = Object.assign([], materials);
        if (tempMaterials.some(x => x.productId === id)) {
            tempMaterials.find(x => x.productId === id).silo = siloName;
        }
        else {
            let quantityNeeded = props.productionOrder.bomIn.find(y => y.productId === id).quantityToConsume;
            tempMaterials.push({ productId: id, quantity: quantityNeeded, silo: siloName, barcode: "", articleNumber: "", purchaseOrderNumber: "" });
        }

        setMaterials(tempMaterials);
        checkValidationOK(tempMaterials);
    }

    function barcodeChanged(e, id, articleNumber) {
        let tempMaterials = Object.assign([], materials);
        if (tempMaterials.some(x => x.productId === id)) {
            tempMaterials.find(x => x.productId === id).barcode = e.target.value.toString();
        }
        else {
            let quantityNeeded = props.productionOrder.bomIn.find(y => y.productId === id).quantityToConsume;
            tempMaterials.push({ productId: id, quantity: quantityNeeded, silo: "", barcode: e.target.value, articleNumber: articleNumber, purchaseOrderNumber: "" });
        }

        setMaterials(tempMaterials);
        checkValidationOK(tempMaterials);
    }

    function checkValidationOK(materials) {
        if (materials.some(x => x.silo !== "" || x.barcode !== "")) {
            if (!validationOK) {
                setValidationOK(true);
            }
        }
        else {
            if (validationOK) {
                setValidationOK(false);
            }
        }
    }

    function addMaterialAmounts() {

        dataService.assignQuantityAtMachine(materials, props.workstation.selectedWorkstation, props.productionOrder.id).then((result) => {
            let wrongBarCodeOrEmptyPallet = false;
            if (result.wrongBarcode) {
                wrongBarCodeOrEmptyPallet = true;
                setDialogTitle(t("Wrong barcode!"))
                if (result.errorMessages.filter(x => x.includes("Barcode")).length > 1) {
                    let barcodeString = result.errorMessages.filter(x => x.includes("Barcode")).map(x => x.substring(8, x.length)).join(" & ");
                    setDialogContext(t("Barcodes scanned for additives ") + barcodeString + t(" are not assigned to order ") + props.productionOrder.reference);
                }
                else {
                    setDialogContext(t("Barcode scanned for additive ") + result.errorMessages.filter(x => x.includes("Barcode"))[0].substring(8, result.errorMessages.filter(x => x.includes("Barcode"))[0].length) + t(" is not assigned to order ") + props.productionOrder.reference);
                }

                setWrongBarcodeDialogOpen(true);
            }
            if (result.emptyPallet) {
                wrongBarCodeOrEmptyPallet = true;
                setDialogTitle2(t("Empty pallet!"));
                if (result.errorMessages.filter(x => x.includes("Article")).length > 1) {
                    let articleString = result.errorMessages.filter(x => x.includes("Article")).map(x => x.substring(8, x.length)).join(" & ");
                    setDialogContext2(t("Pallets scanned for additives ") + articleString + t(" are empty!"));
                }
                else {
                    setDialogContext2(t("Pallet scanned for additive ") + result.errorMessages.filter(x => x.includes("Article"))[0].substring(8, result.errorMessages.filter(x => x.includes("Article"))[0].length) + t(" is empty!"));
                }
                setEmptyPalletDialogOpen(true);
            }
            if (!result.succeeded && !wrongBarCodeOrEmptyPallet) {
                setDialogTitle(t("Error"));
                setDialogContext(result.errorMessages[0]);
                setWrongBarcodeDialogOpen(true);
                return;
            }

            if (result.additivesRemoved) {
                setDialogTitle(t("Additives removed!"));
                setDialogContext(t("Additives from previous pallet are removed from the machine!"));
                setWrongBarcodeDialogOpen(true);
            }

            if (!wrongBarCodeOrEmptyPallet) {
                setMaterials([]);
                if (!result.additivesRemoved) {
                    props.opendrawer(false);
                }
                props.refreshQuantitiesAssigned();
            }
        }
        ).catch((error) => { toast.error(error, { position: "top-center" }) })
    }

    function closeDrawer() {
        setMaterials([]);
        props.opendrawer(false);
    }

    const closeWrongBarcodeDialog = () => {
        setWrongBarcodeDialogOpen(false);
        if (!emptyPalletDialogOpen) {
            closeDrawer();
            props.refreshQuantitiesAssigned();
        }
    }

    const closeEmptyPalletDialog = () => {
        setEmptyPalletDialogOpen(false);
        if (!wrongBarcodeDialogOpen) {
            closeDrawer();
            props.refreshQuantitiesAssigned();
        }
    }

    return <Drawer variant="temporary" className={classes.drawer} anchor='right' open={props.draweropen} classes={{ paper: clsx({ [classes.drawerOpen]: props.draweropen, [classes.drawerClose]: !props.draweropen, }), }} onClose={() => closeDrawer()} transitionDuration={500}>
        <div className={classes.drawerBody}>
            <div className={classes.header}>
                <div className={classes.title}>{t("Manual replenishment")}</div>
                <div className={classes.close}>
                    <Button className={classes.closeButton} onClick={() => closeDrawer()}>
                        <CloseIcon className={classes.closeButtonIcon}></CloseIcon>
                    </Button>
                </div>
            </div>
            <Formik
                initialValues={initialValues}
                validationSchema={Yup.object().shape(shape)}
            >
                {({ isValid }) => (
                    <Form autoComplete="off">
                        <div className={classes.materials}>
                            <div className={classes.tableTitle}>
                                {t("How much would you like to add?")}
                            </div>
                            <div className={classes.consumptionTable}>
                                <RawMaterialsTable siloChanged={siloChanged} productionOrder={props.productionOrder} {...props}></RawMaterialsTable>
                                <AdditivesTable barcodeChanged={barcodeChanged} productionOrder={props.productionOrder} {...props}></AdditivesTable>
                            </div>
                        </div>
                        <div className={classes.addMaterialAmounts}>
                            <GreenButton onClick={addMaterialAmounts} text={"ADD MATERIAL AMOUNTS"} disabled={!isValid || !validationOK}></GreenButton>
                        </div>
                    </Form>
                )}
            </Formik>
            <AlertDialog dialogOpen={emptyPalletDialogOpen} action={closeEmptyPalletDialog} closeDialog={closeEmptyPalletDialog} dialogTitle={dialogTitle2} dialogContext={dialogContext2}></AlertDialog>
            <AlertDialog dialogOpen={wrongBarcodeDialogOpen} action={closeWrongBarcodeDialog} closeDialog={closeWrongBarcodeDialog} dialogTitle={dialogTitle} dialogContext={dialogContext}></AlertDialog>
        </div>
    </Drawer>
}

const useStyles = makeStyles(() => ({
    drawerBody: {
        width: "100%",
        padding: "40px",
        paddingTop: "0px",
        paddingLeft: "20px"

    },
    closeButton: {
        float: "right",
        "&:hover": {
            background: "#EFEFEF"
        },
        paddingRight: "0px !important",
        width: "36px !important",
        height: "36px !important",
        minWidth: "36px !important",
        marginTop: "10px"
    },
    closeButtonIcon: {
        marginRight: "6px"
    },
    drawerOpen: {
        width: "60%",
        backgroundColor: "#EFEFEF",
        paddingRight: "40px",
    },
    drawerClose: {
        width: 0
    },
    header: {
        fontSize: "32px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#000000",
        width: "100%",
        height: '70px',
        display: "block"
    },
    tableTitle: {
        fontSize: "18px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#8D8D8D",
        marginBottom: "30px"
    },
    title: {
        width: "80%",
        float: 'left',
        marginTop: "20px",
    },
    materials: {
        display: 'block',
        width: "100%"
    },
    label: {
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        color: "#020100",
    },
    headCell: {
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        color: "#020100",
        padding: "0px",
        paddingLeft: "5px",
        border: "none",
        height: "10px",
        lineHeight: "0px"
    },
    typeCell: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        color: "#020100",
        padding: "5px",
        borderTop: "1px solid #DEDEDE",
        borderBottom: "1px solid #DEDEDE",
        borderLeft: "1px solid #DEDEDE",
        borderRadius: "6px 0 0 6px",
        backgroundColor: "white",
        paddingLeft: "20px"
    },
    infoCell: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#020100",
        padding: "5px",
        borderTop: "1px solid #DEDEDE",
        borderBottom: "1px solid #DEDEDE",
        backgroundColor: "white"
    },
    amountCell: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#020100",
        padding: "5px",
        borderTop: "1px solid #DEDEDE",
        borderBottom: "1px solid #DEDEDE",
        borderRight: "1px solid #DEDEDE",
        borderRadius: " 0 6px 6px 0",
        backgroundColor: "white",
        width: "30%",
    },
    table: {
        borderSpacing: "0 5px !important",
        borderCollapse: "separate !important",
        width: "100%"

    },
    batchnumberTextField: {
        width: "100%"
    },
    quantityTextField: {
        width: "100%"
    },
    addMaterialAmounts: {
        width: "100%",
        textAlign: "center",
        marginTop: "40px"
    },

}));